import { CreditCard, DollarSign } from "lucide-react";

import type { PaymentTypeIconProps  } from "@/types/tip_plata";



/**
 * Icon pentru tipul de plată (card / cash)
 */
const PaymentTypeIcon = ({ tip_plata, className = "w-4 h-4" }: PaymentTypeIconProps) => {
  if (tip_plata.toLowerCase() === "card") {
    return <CreditCard className={`${className} text-blue-500`} />;
  }
  return <DollarSign className={`${className} text-green-500`} />;
};

export default PaymentTypeIcon;
